export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "colorConverter": {
    "title": "Color Converter",
    "subtitle": "Convert between HEX, RGB, HSL, CMYK. Check contrast, explore harmonies. ",
    "privacy": "100% client-side",
    "random": "Random",
    "contrast": "Contrast Check (WCAG)",
    "whiteText": "White Text",
    "blackText": "Black Text",
    "harmonies": "Color Harmonies",
    "original": "Original",
    "complementary": "Complementary",
    "analogous1": "Analogous +30°",
    "analogous2": "Analogous -30°",
    "triadic1": "Triadic +120°",
    "triadic2": "Triadic +240°",
    "split": "Split Comp.",
    "cssExport": "CSS Export",
    "invalidHex": "Invalid HEX color"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All color processing happens locally in your browser. No color data is uploaded to any server."
    },
    "guide": {
      "title": "How to Use Color Converter",
      "description": "Convert between HEX, RGB, HSL, and CMYK color formats instantly.",
      "steps": [
        {
          "title": "Input your color",
          "description": "Enter a color in any supported format: HEX (#ff5733), RGB (rgb(255,87,51)), HSL, or CMYK. The tool auto-detects the format."
        },
        {
          "title": "Explore conversions",
          "description": "View instant conversions to all other formats. Adjust sliders to tweak individual channels and see real-time updates."
        },
        {
          "title": "Check contrast and harmonies",
          "description": "Use the built-in contrast checker for accessibility compliance, and explore complementary, triadic, and analogous color harmonies."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Instant conversion between HEX, RGB, HSL, and CMYK",
        "Auto-detection of input color format",
        "WCAG contrast ratio checker for accessibility",
        "Color harmony explorer: complementary, triadic, analogous",
        "One-click copy for any color format",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my color data sent to a server?",
          "answer": "No. All color conversions and calculations happen locally in your browser. No data is transmitted or stored externally."
        },
        {
          "question": "What color formats are supported?",
          "answer": "The converter supports HEX (with and without alpha), RGB/RGBA, HSL/HSLA, and CMYK. All conversions are mathematically precise based on standard color space definitions."
        },
        {
          "question": "How is contrast ratio calculated?",
          "answer": "Contrast ratio is calculated using the WCAG 2.1 formula based on relative luminance. A ratio of 4.5:1 is required for normal text, and 3:1 for large text."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Gradient Generator",
          "url": "/design/gradient-generator",
          "description": "Create beautiful CSS gradients with linear, radial, and conic options."
        },
        {
          "name": "Image Converter",
          "url": "/image/image-converter",
          "description": "Convert between JPG, PNG, and WebP instantly in your browser."
        },
        {
          "name": "CSS Minifier",
          "url": "/developer/css-minifier",
          "description": "Compress CSS to reduce file size for faster page loads."
        }
      ]
    }
  }
};
